import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-reveal";
import { translate } from "../../i18n";
import { technologies } from "../../portfolio";

export default function Skills(props) {
  const theme = props.theme;
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="skills-header" style={{ color: theme.text }}>
            {translate("What I Do?")}
          </h1>
        </Fade>
      </div>
      <SkillSection theme={theme} />
      <section
        className="technologies-section"
        aria-labelledby="technologies-title"
      >
        <Fade bottom duration={650} distance="20px">
          <h2
            id="technologies-title"
            className="skills-header"
            style={{ color: theme.text }}
          >
            {technologies.title}
          </h2>
        </Fade>
        <div className="technologies-grid">
          {technologies.groups.map((group, index) => (
            <Fade
              bottom
              duration={700}
              distance="24px"
              delay={index * 120}
              key={group.title}
            >
              <article className="technology-group">
                <div className="technology-group-heading">
                  <span
                    className="iconify"
                    data-icon={group.icon}
                    aria-hidden="true"
                  />
                  <span className="technology-group-number" aria-hidden="true">
                    0{index + 1}
                  </span>
                </div>
                <h3>{group.title}</h3>
                <ul>
                  {group.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </article>
            </Fade>
          ))}
        </div>
      </section>
    </div>
  );
}
